/**
 * Created by Carry on June/12/18.
 */
import FJUtil from '../util/FJUtil';
import FJEvent from './FJEvent';
import FJConstant from '../constants/FJConstant';
import FJConfig from '../config/FJConfig';
import FJTextToVideoStore from './FJTextToVideoStore';

let _currentTag = 'en';
let _languages = {};
let callbacks = new Set();
let FJLocalStore = {
    _: function (key) {
        try {
            let val = this.language()[key];
            if (typeof val === 'undefined') val = _languages[_currentTag][key];
            if (typeof val === 'undefined') val = key;
            return val;
        } catch (e) {
            // console.log(e);
            return key;
        }
    },
    getLanguageFromUrl: function () {
        let url = document.location.href;
        let tag = 'en';
        if (window.locale) {
            let code = window.locale.toLowerCase();
            if (code.indexOf('cn') !== -1) tag = 'cn';
            else if (code.indexOf('tw') !== -1) tag = 'tw';
            else if (code.indexOf('ja') !== -1 || code.indexOf('jp') !== -1) tag = 'jp';
            else if (code.indexOf('fr') !== -1) tag = 'fr';
            else if (code.indexOf('de') !== -1) tag = 'de';
            else if (code.indexOf('es') !== -1) tag = 'es';
            else if (code.indexOf('pt') !== -1) tag = 'pt';
            else if (code.indexOf('it') !== -1) tag = 'en';
            else if (code.indexOf('ar') !== -1) tag = 'ar';
        } else {
            if (url.indexOf('/cn/') !== -1) {
                tag = 'cn';
            } else if (url.indexOf('/tw/') !== -1) {
                tag = 'tw';
            } else if (url.indexOf('/de/') !== -1) {
                tag = 'de';
            } else if (url.indexOf('/es/') !== -1) {
                tag = 'es';
            } else if (url.indexOf('/fr/') !== -1) {
                tag = 'fr';
            } else if (url.indexOf('/pt/') !== -1) {
                tag = 'pt';
            } else if (url.indexOf('/jp/') !== -1) {
                tag = 'jp';
            } else if (url.indexOf('/it/') !== -1) {
                tag = 'en';
            } else if (url.indexOf('/ar/') !== -1) {
                tag = 'ar';
            }
        }
        return tag;
    },
    initLanguage: function (callback) {
        const tag = this.getLanguageFromUrl();
        this.switchLanguage(tag, callback);
    },
    switchLanguage: function (tag, callback) {
        _currentTag = tag;
        if (typeof _languages[tag] === 'undefined') {
            FJUtil.getLanguage(tag, data => {
                if (data) {
                    _languages[tag] = data;
                    FJEvent.dispatch(FJConstant.LANGUAGE_CHANGED);
                    if (callback) callback({ state: 'success' });
                } else {
                    if (callback) callback({ state: 'error' });
                }
            });
        } else {
            FJEvent.dispatch(FJConstant.LANGUAGE_CHANGED);
            if (callback) callback({ state: 'success' });
        }
        if (!FJUtil.isLocalhost() && !FJUtil.isSpecialPage()) {
            let linkTag = tag === 'en' ? `` : `/${tag}`;
            const { origin, search } = window.location;
            const appType = FJTextToVideoStore.getAppType() || FJConfig.appType || FJConfig.currentMenuName;
            const href = FJUtil.getAIToolHref(appType) || FJUtil.getAIToolHref(FJConfig.currentMenuName);
            FJUtil.changeLocation(`${origin}${linkTag}${href}${search}`);
        }
    },
    language: function () {
        return _languages[_currentTag];
    },
    currentTag: function () {
        return _currentTag;
    },
    subscribe: function (callback) {
        callbacks.add(callback);
        return () => {
            callbacks.delete(callback);
        };
    },
    getJumpUrl: function (url) {
        let tag = _currentTag === 'en' ? '' : '/' + _currentTag;
        return tag + url;
    },
};
if (!FJUtil.isSpecialPage()) {
    window.languageChange = (() => {
        let tmp = window.languageChange;
        return tag => {
            FJLocalStore.switchLanguage(tag, () => {
                const appType = FJTextToVideoStore.getAppType() || FJConfig.appType || FJConfig.currentMenuName;
                FJUtil.updateDocumentTitle(appType);
            });
            if (window.changeSubscriptionLocalLanguage) {
                window.changeSubscriptionLocalLanguage(tag);
            }
            if (window.changeGlobalEventLocalLanguage) {
                window.changeGlobalEventLocalLanguage(tag);
            }
            if (typeof tmp === 'function') {
                tmp(tag);
            }
        };
    })();
}

export default FJLocalStore;
